import { useState } from "react";
import { api } from "@app/api/carApi.generated";
import { usePlanId } from "@app/hooks/usePlanId";

export const useBlackDiamondSearch = () => {
  const planId = usePlanId();
  const [searchAccounts, { isFetching: isAccountsLoading, data: accounts }] =
    api.useLazyQuestionnaireExternalBlackDiamondSearchAccountsListQuery();
  const [
    searchPortfolios,
    { isFetching: isPortfoliosLoading, data: portfolios },
  ] = api.useLazyQuestionnaireExternalBlackDiamondSearchPortfoliosListQuery();

  const [
    searchPortfolioAccounts,
    { isFetching: isPortfolioAccountsLoading, data: portfolioAccounts },
  ] = api.useLazyQuestionnaireExternalBlackDiamondPortfolioAccountsListQuery();

  const [showPortfolios, setShowPortfolios] = useState(false);
  const [showAccounts, setShowAccounts] = useState(false);
  const [selectedPortfolioId, setSelectedPortfolioId] = useState<
    string | undefined
  >();

  const [linkRel, { isLoading: linkIsLoading }] =
    api.useQuestionnairePlanAccountsLinkExternalCreateMutation();

  const handleLink = (accountIds: string[]) => {
    linkRel({
      planId,
      linkBlackDiamondAccounts: {
        integrator: "BlackDiamond",
        account_ids: accountIds,
      },
    });
  };

  const handleSearch = (searchCriterion: string, accounts: boolean) => {
    setSelectedPortfolioId(undefined);
    if (accounts) {
      searchAccounts({ searchCriterion });
      setShowPortfolios(false);
      setShowAccounts(true);
    } else {
      searchPortfolios({ searchCriterion });
      setShowPortfolios(true);
      setShowAccounts(false);
    }
  };

  const handleSelect = () => {
    if (showPortfolios) {
      searchPortfolioAccounts({
        externalPortfolioId: selectedPortfolioId ?? "",
      });
      setShowPortfolios(false);
      setShowAccounts(true);
    }
  };

  const handleBack = () => {
    setShowAccounts(false);
    setShowPortfolios(true);
    // setSelectedPortfolio(undefined);
  };

  return {
    showAccounts,
    accounts:
      (selectedPortfolioId
        ? isPortfolioAccountsLoading
          ? []
          : portfolioAccounts
        : accounts) ?? [],
    showPortfolios,
    portfolios: portfolios ?? [],
    isAccountsLoading,
    isPortfoliosLoading,
    isPortfolioAccountsLoading,
    isSelecting: isPortfolioAccountsLoading,
    isSearching: isAccountsLoading || isPortfoliosLoading,
    selectedPortfolioId,
    handleSelectedPortfolioIdChange: setSelectedPortfolioId,
    handleSelect,
    handleSearch,
    handleBack,
    linkIsLoading,
    handleLink,
  };
};
